import React, { useMemo } from 'react'

import { CartesianGrid, Legend, Line, LineChart, XAxis, YAxis } from 'recharts'
import R from 'ramda'
import moment from 'moment'
import numeral from 'numeral'

const OperationalTruwupLineGraph = ({
  width = 730,
  height = 250,
  tdata = {},
  startDate = moment('2024-01-01'),
  endDate = moment('2024-01-30'), // put +1 days
}) => {
  const { optr = [] } = tdata

  const parseIntFunc = val => parseInt(val)

  const optrGroup = useMemo(
    _ =>
      R.compose(
        R.fromPairs,
        R.map(d => [d.date, parseIntFunc(d.value1)])
      )(optr),
    [optr]
  )

  const data = useMemo(
    _ => {
      let effStartMoment = moment(startDate).clone()
      const effEndDate = moment(endDate).clone()
      const dateFormat = 'YYYY-MM-DD'
      const odata = []
      while (effStartMoment.isSameOrBefore(effEndDate)) {
        const f = effStartMoment.format(dateFormat)
        const dt = {
          date: effStartMoment.toDate().getTime(),
          optr: optrGroup[f],
        }
        odata.push(dt)
        effStartMoment = effStartMoment.clone().add(1, 'day')
      }
      return odata
    },
    [optrGroup, endDate, startDate]
  )

  return (
    <div>
      <div
        style={{ paddingLeft: '10%', fontSize: '20px', textAlign: 'center' }}
      >
        CommOps Operational True Up
      </div>
      <LineChart
        height={height}
        width={width}
        data={data}
        margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="date"
          scale="time"
          tickFormatter={d => moment(d).format('MM/DD')}
        />
        <YAxis
          yAxisId="yaxis"
          type="number"
          scale="auto"
          domain={[0, 'auto']}
          allowDataOverflow
          tickFormatter={num =>
            '$' + numeral(numeral(num).value() / 1000000).format('0.00') + 'M'
          }
        />

        {/* <Tooltip /> */}
        <Legend align="center" verticalAlign="bottom" />
        <Line
          type="line"
          dataKey="optr"
          stroke="blue"
          yAxisId="yaxis"
          name="OPTR"
          dot={false}
        />
      </LineChart>
    </div>
  )
}

export default OperationalTruwupLineGraph
